var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPerchSecurity = function SvgPerchSecurity(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.716 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 21.131c-4.765 3.628-11.938 3.746-18.88.745L11.66 13s11.985 4.507 7.22 8.131z",
    fill: "#b27cff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M14.417 19C9.106 19 4.091 15.093 1 9h19s-.272 10-5.583 10z",
    fill: "#adaeff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M27 11.531a9.354 9.354 0 01-12.778 3.14C9.867 12.024 7.644 6.4 8.046 0z",
    fill: "#62c9ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M27 11.864a13.866 13.866 0 00-18.6 4.423C4.555 22.447 5.34 30.18 10.681 38z",
    fill: "#99de00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.717 26.413a9.558 9.558 0 00-3.323-13.286 10 10 0 00-13.572 3.253 9.558 9.558 0 003.324 13.288 10 10 0 0013.571-3.255z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Oval",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(16 14)",
    fill: "#424242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M26.243 13L16 29.592a9.979 9.979 0 0013.567-3.265A9.605 9.605 0 0026.243 13z",
    fill: "#ff9a96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Oval",
    d: "M29.107 15.118c.18-.207.02-.634-.36-.958s-.848-.427-1.028-.22-.019.633.359.96.847.424 1.03.218z",
    fill: "#ff9a96"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerchSecurity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/perch-security.873b21ce.svg";
export { ForwardRef as ReactComponent };